import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import Util from '@/common/utils/Util';
import Main from '@/views/main/index.vue';
import Search from '@/views/search/index';
import SearchResult from '@/views/search/result/index';

import {
  isInsertToGo,
  isPassedTokenCheck,
  notRegisteredRoutePath,
  shouldForceRelogin,
  disconnectSocket,
  keepAlive,
  heartBeat,
  requiresActiveSessionCheck
} from '@/router/navigationGuards';
import LocaleManager from '@/common/utils/LocaleManager';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';

const updateRouteLayout = async (meta) => {
  await store.dispatch('layout/updateRouteLayout', {
    isHeader: meta.isHeader,
    titleName: meta.titleName,
    isBack: meta.isBack,
    isNav: meta.isNav,
    isArea: meta.isArea,
    isCart: meta.isCart,
    isShare: meta.isShare,
    isSearch: meta.isSearch,
    isHome: meta.isHome,
    isStore: meta.isStore
  });
};

const routes = [
  //main
  {
    path: '/',
    name: 'Root',
    component: () => import('@/views/root')
  },
  {
    path: '/main',
    name: 'MainIndex',
    // component: () => import( '@/views/main/index.vue'),
    component: Main,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: false,
      titleName: '',
      isArea: true,
      isCart: true,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },

  //address
  {
    path: '/address/find',
    name: 'AddressFind',
    component: () => import('@/views/address/find/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: 'address.find.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/address/:userNo',
    name: 'AddressDetail',
    component: () => import('@/views/address/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'address.add_form.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/address/map',
    name: 'AddressMap',
    component: () => import('@/views/address/map/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'address.map.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/address/currentMap',
    name: 'Current_AddressMap',
    component: () => import('@/views/address/map/CurrentMap'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'address.map.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/my/address/currentMap',
    name: 'My_Current_AddressMap',
    component: () => import('@/views/my/address/map/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'address.map.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },

  //search
  {
    path: '/search',
    name: 'Search',
    // component: () => import( '@/views/search/index'),
    component: Search,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/search/product/:storeNo/:productNo',
    name: 'SearchProductDetail',
    component: () => import('@/views/search/product/detail'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/search/result',
    name: 'SearchResultBasic',
    // component: () => import( '@/views/search/result/index'),
    component: SearchResult,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: true,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },
  {
    path: '/search/result/:storeCategoryNo',
    name: 'SearchResult',
    // component: () => import( '@/views/search/result/index'),
    component: SearchResult,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: true,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },

  //tag
  {
    path: '/tag/:tagNo/:tagName',
    name: 'Tag',
    component: () => import('@/views/tag/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: true,
      isCart: false,
      isShare: false,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },

  //promotion
  {
    path: '/promotion',
    name: 'Promotion',
    component: () => import('@/views/promotion/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: true,
      isCart: false,
      isShare: true,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },

  {
    // 신규상점
    path: '/new',
    name: 'NewStore',
    component: () => import('@/views/new/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: true,
      isCart: true,
      isShare: true,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },

  //bestOrder
  {
    path: '/bestOrder',
    name: 'BestOrder',
    component: () => import('@/views/bestOrder/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      isArea: true,
      isCart: false,
      isShare: true,
      isSearch: true,
      isHome: false,
      isStore: false
    }
  },

  ///shop
  {
    path: '/shop/:storeNo',
    name: 'Store',
    component: () => import('@/views/store/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: true,
      isSearch: false,
      isHome: false,
      isStore: true
    },
    children: [
      {
        path: '/shop/:storeNo/product',
        name: 'StoreProduct',
        component: () => import('@/views/store/product/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: '',
          isArea: false,
          isCart: true,
          isShare: true,
          isSearch: false,
          isHome: true,
          isStore: true
        }
      },
      {
        path: '/shop/:storeNo/comment',
        name: 'StoreReview',
        component: () => import('@/views/store/review/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: '',
          isArea: false,
          isCart: true,
          isShare: true,
          isSearch: false,
          isHome: true
        }
      },
      {
        path: '/shop/:storeNo/information',
        name: 'StoreInformation',
        component: () => import('@/views/store/information/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: '',
          isArea: false,
          isCart: true,
          isShare: true,
          isSearch: false,
          isHome: true
        }
      },
      {
        path: '/shop/:storeNo/category',
        name: 'StoreCategory',
        component: () => import('@/views/store/category/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: '',
          isArea: false,
          isCart: true,
          isShare: true,
          isSearch: false,
          isHome: true
        }
      },
      {
        path: '/shop/:storeNo/search',
        name: 'StoreSearch',
        component: () => import('@/views/store/search/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: '',
          isArea: false,
          isCart: true,
          isShare: true,
          isSearch: false,
          isHome: true
        }
      }
    ]
  },
  {
    path: '/shop/:storeNo/product/:productNo',
    name: 'StoreProductDetail',
    component: () => import('@/views/store/product/detail'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: true,
      isSearch: false,
      isHome: false,
      isStore: true
    }
  },

  //cart
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/cart/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'cart.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: true,
      isStore: false
    }
  },

  //order
  {
    path: '/order',
    name: 'OrderOnGoing',
    component: () => import('@/views/order/onGoing/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'order.on_going.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: true
    }
  },
  {
    path: '/order/map',
    name: 'OrderCurrentMap',
    component: () => import('@/views/order/CurrentMap.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'address.map.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: true
    }
  },
  {
    path: '/order/success',
    name: 'OrderSuccess',
    component: () => import('@/views/order/success/index'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: true
    }
  },
  {
    path: '/order/failure',
    name: 'OrderFailure',
    component: () => import('@/views/order/failure/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: false,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: true
    }
  },

  //chat
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/chat/lobby/index'),
    redirect: '/chat/order',
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: 'chat.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    children: [
      {
        path: '/chat/order',
        name: 'ChatOrder',
        component: () => import('@/views/chat/lobby/order/index'),
        meta: {
          isHeader: true,
          isNav: true,
          isBack: false,
          titleName: 'chat.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/chat/inquiry',
        name: 'ChatInquiry',
        component: () => import('@/views/chat/lobby/inquiry/index'),
        meta: {
          isHeader: true,
          isNav: true,
          isBack: false,
          titleName: 'chat.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false,
          isStore: false
        }
      },
      {
        path: '/chat/all',
        name: 'ChatAll',
        component: () => import('@/views/chat/lobby/all/index'),
        meta: {
          isHeader: true,
          isNav: true,
          isBack: false,
          titleName: 'chat.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      }
    ]
  },

  //room
  {
    path: '/room/:roomNo/:type',
    name: 'Room',
    component: () => import('@/views/chat/room/ChatRoom.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    }
  },

  //orderHistory
  {
    path: '/order/history',
    name: 'OrderHistory',
    component: () => import('@/views/my/order/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: false,
      titleName: 'my.order.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isStore: false,
      isHome: false
    }
  },

  //fav
  {
    path: '/fav',
    name: 'Fav',
    component: () => import('@/views/my/fav/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.fav.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    redirect: '/fav/shop',
    children: [
      {
        path: '/fav/shop',
        name: 'FavStore',
        component: () => import('@/views/my/fav/store/index'),
        meta: {
          isHeader: true,
          isNav: true,
          isBack: true,
          titleName: 'my.fav.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isStore: false,
          isHome: false
        }
      },
      {
        path: '/fav/product',
        name: 'FavProduct',
        component: () => import('@/views/my/fav/product/index'),
        meta: {
          isHeader: true,
          isNav: true,
          isBack: true,
          titleName: 'my.fav.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isStore: false,
          isHome: false
        }
      }
    ]
  },

  //my
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/my/index'),
    meta: {
      isHeader: true,
      isNav: true,
      isStore: false,
      isBack: false,
      titleName: 'my.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/info',
    name: 'MyInfo',
    component: () => import('@/views/my/info/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.info.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/notification',
    name: 'MyNotification',
    component: () => import('@/views/my/notification/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.alert.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/notification/:pushNo',
    name: 'MyNotificationDetail',
    component: () => import('@/views/my/notification/PushDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.alert.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/password/:userNo',
    name: 'MyPassword',
    component: () => import('@/views/my/changePassword/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.password.button.confirm',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/withdraw/:userNo',
    name: 'MyWithdraw',
    component: () => import('@/views/my/withdraw/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.withdraw.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/withdraw/inquiry',
    name: 'MyWithdrawInquiry',
    component: () => import('@/views/my/withdraw/withdraw.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.cs.withdraw.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/point/:userNo',
    name: 'MyPoint',
    component: () => import('@/views/my/point/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.point.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/coupon/:userNo',
    name: 'MyCoupon',
    component: () => import('@/views/my/coupon/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.coupon.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/review/:userNo',
    name: 'MyReview',
    component: () => import('@/views/my/review/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.review.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/review/:userNo/:storeNo/:orderNo',
    name: 'MyReviewForm',
    component: () => import('@/views/my/review/form/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.review.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/order/history',
    name: 'MyOrderHistory',
    component: () => import('@/views/my/order/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.order.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/order/history/product/:storeNo/:productNo',
    name: 'MyOrderProductDetail',
    component: () => import('@/views/my/order/product/detail'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: true,
      isShare: true,
      isSearch: false,
      isHome: false,
      isStore: true
    }
  },
  {
    path: '/my/order/history/:orderNo',
    name: 'MyOrderDetail',
    component: () => import('@/views/my/order/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.order.detail.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/fav',
    name: 'MyFav',
    component: () => import('@/views/my/fav/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.fav.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    redirect: '/my/fav/shop',
    children: [
      {
        path: '/my/fav/shop',
        name: 'MyFavStore',
        component: () => import('@/views/my/fav/store/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'my.fav.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/my/fav/product',
        name: 'MyFavProduct',
        component: () => import('@/views/my/fav/product/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'my.fav.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      }
    ]
  },
  {
    path: '/my/address',
    name: 'MyAddress',
    component: () => import('@/views/my/address/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.address.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/recent',
    name: 'MyRecent',
    component: () => import('@/views/my/recent/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.recent.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    redirect: '/my/recent/shop',
    children: [
      {
        path: '/my/recent/shop',
        name: 'MyRecentStore',
        component: () => import('@/views/my/recent/store/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'my.recent.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/my/recent/product',
        name: 'MyRecentProduct',
        component: () => import('@/views/my/recent/product/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'my.recent.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      }
    ]
  },
  {
    path: '/my/service',
    name: 'MyService',
    component: () => import('@/views/my/service/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/service/cs',
    name: 'MyCs',
    component: () => import('@/views/my/service/cs/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.cs.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  {
    path: '/customer-service',
    name: 'unknown-cs',
    component: () => import('@/views/my/temp/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.cs.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/service/cs/:csNo',
    name: 'MyCsDetail',
    component: () => import('@/views/my/service/cs/detail/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.cs.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/service/cs/form',
    name: 'MyCsForm',
    component: () => import('@/views/my/service/cs/form/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.cs.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/service/faq',
    name: 'MyFaq',
    component: () => import('@/views/my/service/faq/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.service.faq.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/notice',
    name: 'MyNotice',
    component: () => import('@/views/my/notice/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.notice.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/notice/:noticeNo',
    name: 'MyNoticeDetail',
    component: () => import('@/views/my/notice/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.notice.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/event',
    name: 'MyEvent',
    component: () => import('@/views/my/event/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.event.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/event/:eventNo',
    name: 'MyEventDetail',
    component: () => import('@/views/my/event/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.event.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/settings',
    name: 'MySettings',
    component: () => import('@/views/my/settings/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.settings.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/terms',
    name: 'MyTerms',
    component: () => import('@/views/my/terms/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'my.terms.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/my/terms/:type',
    name: 'MyTermsDetail',
    component: () => import('@/views/my/terms/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  //sign
  {
    path: '/sign/in',
    name: 'SignIn',
    component: () => import('@/views/sign/in/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  // find password 비밀번호 찾기
  {
    path: '/sign/find',
    name: 'Find_Password',
    component: () => import('@/views/sign/find/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'join.find_password.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  // find password 비밀번호 찾기
  {
    path: '/sign/up',
    name: 'SignUp',
    component: () => import('@/views/sign/up/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'join.join',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  //admin
  {
    path: '/shop',
    name: 'Admin',
    component: () => import('@/views/admin/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    redirect: '/shop/dashboard',
    children: [
      {
        path: '/shop/dashboard',
        name: 'AdminDashBoard',
        component: () => import('@/views/admin/dashboard/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.dashboard.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/shop/store',
        name: 'AdminStore',
        component: () => import('@/views/admin/store/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isStore: false,
          isHome: false
        }
      },
      {
        path: '/shop/store/:storeNo/review',
        name: 'AdminStoreReview',
        component: () => import('@/views/admin/store/review/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/shop/manage',
        name: 'AdminManage',
        component: () => import('@/views/admin/manage/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.manage.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      }
    ]
  },
  //dashBoard

  {
    path: '/shop/dashboard/rank',
    name: 'AdminOrderRank',
    component: () => import('@/views/admin/dashboard/orderRank/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.dashboard.order_rank.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/dashboard/bizMoney/:storeNo',
    name: 'AdminBizMoney',
    component: () => import('@/views/admin/dashboard/bizMoney'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.dashboard.biz_money.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  //store

  {
    path: '/shop/:storeNo/serviceableArea',
    name: 'AdminServiceableArea',
    component: () => import('@/views/admin/store/serviceableArea/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.serviceableArea.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/:storeNo/basic',
    name: 'AdminBasic',
    component: () => import('@/views/admin/store/basic/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.basic.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    },
    children: [
      {
        path: '/shop/:storeNo/basic/info',
        name: 'AdminStoreInfo',
        component: () => import('@/views/admin/store/basic/info/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.basic.info.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/shop/:storeNo/basic/payment',
        name: 'AdminStorePayment',
        component: () => import('@/views/admin/store/basic/payment/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.basic.payment.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/shop/:storeNo/basic/business',
        name: 'AdminStoreBusiness',
        component: () => import('@/views/admin/store/basic/business/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.basic.business.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        },
        children: [
          {
            path: '/shop/:storeNo/basic/businessInfo',
            name: 'AdminStoreBusinessInfo',
            component: () => import('@/views/admin/store/basic/business/info/index'),
            meta: {
              isHeader: true,
              isNav: false,
              isBack: true,
              titleName: 'admin.store.basic.business.header',
              isArea: false,
              isCart: false,
              isShare: false,
              isSearch: false,
              isHome: false
            }
          },
          {
            path: '/shop/:storeNo/basic/businessDelivery',
            name: 'AdminStoreBusinessDelivery',
            component: () => import('@/views/admin/store/basic/business/delivery/index'),
            meta: {
              isHeader: true,
              isNav: false,
              isBack: true,
              titleName: 'admin.store.basic.business.header',
              isArea: false,
              isCart: false,
              isShare: false,
              isSearch: false,
              isHome: false
            }
          },
          {
            path: '/shop/:storeNo/basic/businessReservation',
            name: 'AdminStoreBusinessReservation',
            component: () => import('@/views/admin/store/basic/business/reservation/index'),
            meta: {
              isHeader: true,
              isNav: false,
              isBack: true,
              titleName: 'admin.store.basic.business.header',
              isArea: false,
              isCart: false,
              isShare: false,
              isSearch: false,
              isHome: false
            }
          },
          {
            path: '/shop/:storeNo/basic/businessPacking',
            name: 'AdminStoreBusinessPacking',
            component: () => import('@/views/admin/store/basic/business/packing/index'),
            meta: {
              isHeader: true,
              isNav: false,
              isBack: true,
              titleName: 'admin.store.basic.business.header',
              isArea: false,
              isCart: false,
              isShare: false,
              isSearch: false,
              isHome: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/shop/admin/:storeNo/product',
    name: 'AdminStoreProductList',
    component: () => import('@/views/admin/store/product/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.product.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/admin/:storeNo/product/:productNo',
    name: 'AdminStoreProduct',
    component: () => import('@/views/admin/store/product/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.product.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false,
      isStore: false
    },
    children: [
      {
        path: '/shop/admin/:storeNo/product/:productNo/basic',
        name: 'AdminProductBasic',
        component: () => import('@/views/admin/store/product/detail/basic/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.product.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      },
      {
        path: '/shop/admin/:storeNo/product/:productNo/option',
        name: 'AdminProductOption',
        component: () => import('@/views/admin/store/product/detail/option/index'),
        meta: {
          isHeader: true,
          isNav: false,
          isBack: true,
          titleName: 'admin.store.product.header',
          isArea: false,
          isCart: false,
          isShare: false,
          isSearch: false,
          isHome: false
        }
      }
    ]
  },
  {
    path: '/shop/:storeNo/review',
    name: 'AdminStoreReview',
    component: () => import('@/views/admin/store/review/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.review.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/:storeNo/repl/:reviewNo',
    name: 'AdminStoreRepl',
    component: () => import('@/views/admin/store/review/repl/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.review.repl.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/:storeNo/report/:reviewNo',
    name: 'AdminStoreReportReview',
    component: () => import('@/views/admin/store/review/report/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.store.review.report.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  //manage
  //manage-order
  {
    path: '/shop/manage/order',
    name: 'AdminManageOrder',
    component: () => import('@/views/admin/manage/order/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.order.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/order/:orderNo',
    name: 'AdminManageOrderDetail',
    component: () => import('@/views/admin/manage/order/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.order.detail.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  //manage-biz
  {
    path: '/shop/manage/bizmoney',
    name: 'AdminManageBizMoney',
    component: () => import('@/views/admin/manage/bizMoney/transaction/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.biz_money.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/charge',
    name: 'AdminManageBizMoneyRequest',
    component: () => import('@/views/admin/manage/bizMoney/request/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.charge_request.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  //manage-coupon
  // 쿠폰 발급 리스트
  {
    path: '/shop/manage/issue/list',
    name: 'AdminManageIssueListCoupon',
    component: () => import('@/views/admin/manage/coupon/issue/list/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.issue_coupon.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/issue/create',
    name: 'AdminManageIssueCreateCoupon',
    component: () => import('@/views/admin/manage/coupon/issue/create/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.issue_coupon.create.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/issue/history',
    name: 'AdminManageIssueHistoryCoupon',
    component: () => import('@/views/admin/manage/coupon/issue/history/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.issued_coupon_history.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/notice',
    name: 'AdminManageNotice',
    component: () => import('@/views/admin/manage/notice/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.notice.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/notice/:noticeNo',
    name: 'AdminManageNoticeDetail',
    component: () => import('@/views/admin/manage/notice/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.notice.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  //terms
  {
    path: '/shop/manage/terms',
    name: 'AdminManageTerms',
    component: () => import('@/views/admin/manage/terms/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.terms.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/terms/:type',
    name: 'AdminManageTermsDetail',
    component: () => import('@/views/admin/manage/terms/detail/'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.terms.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },

  {
    path: '/shop/manage/customer',
    name: 'AdminManageCustomer',
    component: () => import('@/views/admin/manage/customer/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.customer.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/customer/:storeNo/:userNo',
    name: 'AdminManageCustomerDetail',
    component: () => import('@/views/admin/manage/customer/detail/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.customer.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  },
  {
    path: '/shop/manage/customer/coupon/:userNo',
    name: 'AdminManageCustomerCoupon',
    component: () => import('@/views/admin/manage/customer/detail/coupon/index'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'admin.manage.customer.detail.coupon_send.header',
      isArea: false,
      isCart: false,
      isShare: false,
      isSearch: false,
      isHome: false
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return { left: 0, top: 0 }
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({ left: 0, top: 0 });
        }
      }, 100);
    });
  }
});

window.routeQuery = '';
window.path = '';

router.beforeEach(async (to, from, next) => {
  let meta = to.meta;
  initializeLocaleSettings();

  if (!Util.isEmpty(store.getters['layout/getModalAlertComponents'])) {
    /** watch route 이동시 sidebar, modal close **/
    await store.dispatch('layout/removeAllModalAlertComponent');
  }
  if (!Util.isEmpty(store.getters['layout/getModalComponents'])) {
    await store.dispatch('layout/removeAllModalComponent');
  }

  await updateRouteLayout(meta);
  window.routeQuery = to.query;
  window.path = to.path;

  if (notRegisteredRoutePath(to, from, next)) return next('/');

  const forceReloginPath = await shouldForceRelogin(to);
  if (forceReloginPath) return next(forceReloginPath);

  if (!(await isPassedTokenCheck(to, from, next))) {
    if (to.path.includes('/my/password/')) return next();
    else if (isInsertToGo(to.path)) return next(`/sign/in?togo=${to.path}`);
    else return next('/sign/in');
  }

  keepAlive(to, from);
  disconnectSocket(to, from, next);
  if (requiresActiveSessionCheck(to.path) && !(await heartBeat())) return next('/');
  return next();
});

const initializeLocaleSettings = () => {
  const { userNo, locale } = store.getters['user/getUserData'];
  const selectedLocale = store.getters['locale/getLocale'];
  if (!userNo || !locale) LocaleManager.setLocale(selectedLocale || CODE_ENV_LIST.DEFAULT_LOCALE);
};

export default router;
